<template>
  <div class="progress-bar">
    <ul class="progress-bar__list">
      <li
        :class="[
          'progress-bar__item',
          {
            'progress-bar__item--active': currentstep === 1,
            'progress-bar__item--done': currentstep > 1,
          },
          {},
        ]"
      >
        <button class="progress-bar__button" @click="quickstep(1)">
          <span class="progress-bar__number">1</span>
          <span class="progress-bar__text">
            Oplysninger om
            {{ privateAdFlowProductTypeNames.nameSingularParticular }}
          </span>
        </button>
      </li>
      <li
        :class="[
          'progress-bar__item',
          {
            'progress-bar__item--active': currentstep === 2,
            'progress-bar__item--done': currentstep > 2,
          },
        ]"
      >
        <button class="progress-bar__button" @click="quickstep(2)">
          <span class="progress-bar__number">2</span>
          <span class="progress-bar__text">
            Fremsøgte
            <br />oplysninger
          </span>
        </button>
      </li>
      <li
        :class="[
          'progress-bar__item',
          {
            'progress-bar__item--active': currentstep === 3,
            'progress-bar__item--done': currentstep > 3,
          },
        ]"
      >
        <button class="progress-bar__button" @click="quickstep(3)">
          <span class="progress-bar__number">3</span>
          <span class="progress-bar__text">
            Dine detaljer om
            {{ privateAdFlowProductTypeNames.nameSingularParticular }}
          </span>
        </button>
      </li>
      <li
        :class="[
          'progress-bar__item',
          {
            'progress-bar__item--active': currentstep === 4,
            'progress-bar__item--done': currentstep > 4,
          },
        ]"
      >
        <button class="progress-bar__button" @click="quickstep(4)">
          <span class="progress-bar__number">4</span>
          <span class="progress-bar__text">
            Pris
            <br />&amp; kontakt
          </span>
        </button>
      </li>
      <li
        :class="[
          'progress-bar__item',
          { 'progress-bar__item--active': currentstep === 5 },
        ]"
      >
        <button class="progress-bar__button" disabled="disabled">
          <span class="progress-bar__number">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 302.9 185.35" v-bind:loading="'lazy'" v-bind:class="'progress-bar__image'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="30" d="M296.9 6L120.59 179.35 6 66.67"/></svg>
          </span>
          <span class="progress-bar__text">
            Godkend
            <br />udgivelse
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    currentstep: { default: null, type: Number },
    eventbus: { default: null, type: Object },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
  },
  methods: {
    quickstep(stepNo) {
      if (stepNo >= this.currentstep) return
      if (this.eventbus == null) return
      this.eventbus.emit('quickstep', stepNo)
    },
  },
}
</script>

<style lang="scss">
@import 'ProgressBar.scss';
</style>
